/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import ProductRow from '../paymentPopup/ProductRow';
import Currency from '../components/numbers/Currency';
import {markProduct, receiptListMove} from '../../common/categories/actions';
import {isOverflowedClass, findFirstElementByClass, findFirstElementByClassInElement} from '../../common/lib/util';
import {isElemetVisible} from '../../common/lib/visibility';

class Receipt extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        selectedProducts: React.PropTypes.object,
        markedProduct: React.PropTypes.oneOfType([
            React.PropTypes.object,
            React.PropTypes.number
        ]),
        totalPriceVat: React.PropTypes.number,
        showTableId: React.PropTypes.string,
        markProduct: React.PropTypes.func,
        receiptListMove: React.PropTypes.func,
        markedProductTable: React.PropTypes.bool,
        payingInProgress: React.PropTypes.bool,
        tables: React.PropTypes.object
    };

    constructor(props) {
        super(props);

        this.scrollToSelectedItem = this.scrollToSelectedItem.bind(this);
        this.receiptListMove = this.receiptListMove.bind(this);
    }

    receiptListMove(up) {
        const {receiptListMove, markedProduct, markedProductTable} = this.props;

        let id;
        let isTable;
        let parent = findFirstElementByClass(`homepageScroll`);

        if (!!markedProduct && parent.childNodes.length > 0) {
            const classToSelect = `item-${markedProduct}-${!!markedProductTable ? 'table' : 'nontable'}`;
            let selectedElement = findFirstElementByClassInElement(parent, classToSelect);

            if (!!selectedElement) {
                if (up) {
                    let previousElement = selectedElement.previousSibling;
                    if (!!previousElement) {
                        if (!previousElement.classList.contains('row')) {
                            previousElement = previousElement.previousSibling;
                        }
                        if (!!previousElement) {
                            id = previousElement.getAttribute('data-id');
                            isTable = previousElement.getAttribute('data-table');
                        }
                    }
                } else {
                    let nextElement = selectedElement.nextSibling;
                    if (!!nextElement) {
                        if (!nextElement.classList.contains('row')) {
                            nextElement = nextElement.nextSibling;
                        }
                        if (!!nextElement) {
                            id = nextElement.getAttribute('data-id');
                            isTable = nextElement.getAttribute('data-table');
                        }
                    }
                }
            }
        } else if (parent.childNodes.length > 0) {
            let selectedElement = findFirstElementByClassInElement(parent, 'row');
            if (!!selectedElement) {
                id = selectedElement.getAttribute('data-id');
                isTable = selectedElement.getAttribute('data-table');
            }
        }

        receiptListMove(id, isTable);
    }

    componentDidUpdate() {
        this.scrollToSelectedItem();
    }

    scrollToSelectedItem() {
        const {markedProduct} = this.props;
        if (!!markedProduct) {
            const isOverflow = isOverflowedClass('homepageScroll');
            if (isOverflow){
                const div = document.getElementsByClassName("homepageScroll")[0];
                if (div.getElementsByClassName('active-main-receipt').length > 0) {
                    const activeDiv = div.getElementsByClassName('active-main-receipt')[0];
                    if (!isElemetVisible(activeDiv)) {
                        div.scrollTop = activeDiv.offsetTop;
                    }
                }
            }
        }
    }

    render() {
        const {
            selectedProducts, tables, totalPriceVat,
            markedProduct, markProduct, showTableId, markedProductTable, msg
        } = this.props;

        const cur = 'CZK';
        let price = !!showTableId ? tables.get(showTableId).get('totalPriceVat') + totalPriceVat : totalPriceVat;
        price = Math.round(price);

        return (
            <section className="receipt" id="receipt">
                <div className="receipt-list list with-controls">
                    <div className="receipt-scroll scroll homepageScroll">
                        {!!showTableId && !!tables.getIn([showTableId, 'products']) && tables.getIn([showTableId, 'products'])
                            .sortBy(item => item.get('addTime'))
                            .map((item, i) =>
                            <ProductRow key={`receipt-item-${i}`}
                                        addClass={`item-${item.get('id')}-table`}
                                        item={item}
                                        isTable={true}
                                        marked={i === markedProduct && markedProductTable}
                                        activeClass="active active-main-receipt"
                                        onClick={markProduct}/>
                        )}
                        {!!showTableId && !!tables.getIn([showTableId, 'products']) &&
                        tables.getIn([showTableId, 'products']).size > 0 && selectedProducts.size > 0 &&
                        <hr className="receipt-hr" />
                        }
                        {selectedProducts
                            .sortBy(item => item.get('addTime'))
                            .map((item, i) =>
                            <ProductRow key={`receipt-item-${i}`}
                                        addClass={`item-${item.get('id')}-nontable`}
                                        item={item}
                                        activeClass="active active-main-receipt"
                                        marked={i === markedProduct && !markedProductTable}
                                        onClick={markProduct}/>
                        )}
                    </div>
                </div>

                <div className="controls receipt-controls">
                  <div className="receipt-arr">
                    <div className="boxBtn color-white" onClick={() => this.receiptListMove(true)}>
                        <div className="boxBtn-inner">
                          <div className="ico-up"></div>
                        </div>
                    </div>
                  </div>
                  <div className="receipt-arr">
                    <div className="boxBtn color-white" onClick={() => this.receiptListMove(false)}>
                        <div className="boxBtn-inner">
                          <div className="ico-down"></div>
                        </div>
                    </div>
                  </div>
                </div>

                <div className="receipt-sum suma">
                    {!showTableId
                        ? <span className="receipt-sum-table">{msg.homepage.receipt.sum}</span>
                        : <span className="receipt-sum-table">{msg.homepage.receipt.table}: {tables.getIn([showTableId, 'name'])}</span>
                    }
                    <span className="receipt-sum-price">
                        <Currency value={price} currency={cur}/>
                    </span>
                </div>
            </section>
        );
    }

}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    selectedProducts: state.categories.get('selectedProducts'),
    markedProduct: state.categories.get('markedProduct'),
    totalPriceVat: state.categories.get('totalPriceVat'),
    tables: state.categories.get('tables'),
    markedProductTable: state.categories.get('markedProductTable'),
    payingInProgress: state.categories.get('payingInProgress'),
    showTableId: state.categories.get('showTableId')
}), {markProduct, receiptListMove})(Receipt);



// WEBPACK FOOTER //
// ./src/browser/home/Receipt.js